import { createSelector } from 'reselect'

export const selectReference = createSelector(
  (state: RootState) => state.project.reference,
  ({ width, height, fpsNum, fpsDenum, id }) => ({ width, height, fpsNum, fpsDenum, id })
)
